import React from 'react';
import uniqBy from 'lodash/uniqBy';

import { UiButton } from 'src/components/UI/Button';
import { ChildrenPropType } from 'src/utils/types';
import isString from 'lodash/isString';

export type ListErrorsMessagesType = (string | { key: string | number; component: ChildrenPropType })[];

type Props = {
  errorMessages: ListErrorsMessagesType;
};

export const ListErrors: React.FC<Props> = ({ errorMessages }) => {
  const iterateeFn = (value: ListErrorsMessagesType[0]) => {
    if (isString(value)) {
      return value;
    }

    return value.key;
  };

  return (
    <ul>
      {uniqBy(errorMessages, iterateeFn).map((item) =>
        isString(item) ? <li key={item}>{item}</li> : <li key={item.key}>{item.component}</li>
      )}
    </ul>
  );
};

/** common modal errors */

type PropsClose = {
  data: ListErrorsMessagesType;

  onClose?: () => void;
};

export const ValidationListErrors: React.FC<PropsClose> = ({ data, onClose }: PropsClose) =>
  data.length ? (
    <div className="alert alert-danger validationReport">
      {onClose && (
        <UiButton tag="a" className="close" onClick={onClose}>
          ×
        </UiButton>
      )}
      <ListErrors errorMessages={data} />
    </div>
  ) : null;
